<template>
  <div>
    <div class="d-flex">
      <AssignmentType :assignment="assignment" />
      <AssignmentDistributionChannel :assignment="assignment" />
      <AssignmentServiceLevel :assignment="assignment" />
    </div>
    <div v-if="isStaff && staffIcons" class="d-flex pt-1">
      <HiddenPrices :label-id="`hidden-prices-${assignment.id}`" :hidden-prices="assignment.company.hidePrice" />
      <AssignmentCustomPrices :assignment="assignment" />
      <AssignmentCustomCarriers :assignment="assignment" />
    </div>
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { defineComponent, type PropType } from 'vue'
import { useAccountStore } from '@/store/account'
import HiddenPrices from '@/views/Components/Labels/HiddenPrices.vue'
import AssignmentType from '@/views/Components/Labels/Type.vue'
import AssignmentCustomPrices from '@/views/Components/Labels/CustomPrices.vue'
import AssignmentServiceLevel from '@/views/Components/Labels/ServiceLevel.vue'
import AssignmentCustomCarriers from '@/views/Components/Labels/CustomCarriers.vue'
import AssignmentDistributionChannel from '@/views/Components/Labels/DistributionChannel.vue'

export default defineComponent({
  name: 'FeaturesCell',
  components: {
    AssignmentServiceLevel,
    AssignmentCustomCarriers,
    AssignmentCustomPrices,
    HiddenPrices,
    AssignmentType,
    AssignmentDistributionChannel,
  },
  props: {
    assignment: {
      type: Object as PropType<Assignment>,
      required: true,
    },
    staffIcons: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return {
      isStaff: useAccountStore().isStaff,
    }
  },
})
</script>
